import Konva from 'konva';
import GraphicBase from './Base';

class GraphicArea extends GraphicBase {
  constructor(payload, stage) {
    super(payload, stage);

    this.canDraggable = true;
  }

  build() {
    const { stage } = this;
    const points = [];

    this.data.forEach((pid) => {
      points.push(stage.pointDict[pid].x, stage.pointDict[pid].y);
    });

    this.ele = new Konva.Line({
      x: this.property.x || 0,
      y: this.property.y || 0,
      id: this.id,
      points,
      fill: 'rgba(0, 0, 255, 0.2)',
      stroke: 'blue',
      strokeWidth: 1,
      closed: true,
    });
    this.ele.on('dragstart', (e) => {
      stage.editLayer.destroyChildren();
      stage.editLayer.draw();
    });
    this.ele.on('dragmove', (e) => {
    });
    this.ele.on('dragend', (e) => {
      this.property.x = this.ele.x();
      this.property.y = this.ele.y();
    });

    this.ele.on('click', (e) => {
      stage.areaClickHandler(e);
    });

    stage.areaLayer.add(this.ele);
    this.layer = stage.areaLayer;

    return this.ele;
  }

  updatePoints() {
    const { stage } = this;
    const points = [];
    this.data.forEach((pid) => {
      points.push(stage.pointDict[pid].x, stage.pointDict[pid].y);
    });
    this.ele.setAttr('points', points);
    this.ele.draw();
  }
}

export default GraphicArea;
